import gql from "graphql-tag";

const SuperAdmin = gql`
	fragment SuperAdmin on SuperAdmin {
		id
		created_at
		revoked
		staff {
			id
			first_name
			surname
			middle_name
			mobile
			designation {
				id
				name
			}
			type {
				id
				name
			}
			department {
				id
				name
			}
			admin
			email
			image
			gender
		}
		grantedBy {
			id
			first_name
			surname
			middle_name
			mobile
			designation {
				id
				name
			}
			type {
				id
				name
			}
			department {
				id
				name
			}
			admin
			email
			image
			gender
		}
	}
`;

const NEW_SUPER_ADMIN = gql`
	mutation NewSuperAdmin($staff: ID!) {
		GrantSuperAdminRights(staff: $staff) {
			message
			doc {
				...SuperAdmin
			}
		}
	}
	${SuperAdmin}
`;

const GET_ADMINS = gql`
	query GetAdmins {
		GetSuperAdmins {
			docs {
				...SuperAdmin
			}
		}
	}
	${SuperAdmin}
`;

const REVOKE = gql`
	mutation RevokeRight($id: ID!) {
		RevokeSuperAdminRights(id: $id) {
			doc {
				...SuperAdmin
			}
			message
		}
	}
	${SuperAdmin}
`;

const RE_ASSIGN = gql`
	mutation CancelRevokeRight($id: ID!) {
		CancelSuperAdminRightsRevoke(id: $id) {
			doc {
				...SuperAdmin
			}
			message
		}
	}
	${SuperAdmin}
`;

const IS_SUPER_ADMIN = gql`
	query IsSuperAdmin($id: ID!) {
		isSuperAdmin(staff: $id)
	}
`;
export { REVOKE, GET_ADMINS, NEW_SUPER_ADMIN, RE_ASSIGN, IS_SUPER_ADMIN };
